import {
    ImprovementCategoryDto,
    ImprovementGroupDto,
    PerformanceClassDto,
} from '../../core';
import { NO_SCORE_NO_CLASS_ID } from '../fixture/no-score-no-class-id';
import { TranslationKeyMap } from '../main.i18n';
import { FilterItemView } from '../model/filter-item-view.model';
import { PerformerItemView } from '../model/performer-item-view.model';

export function determineFilterItems(
    categories: ImprovementCategoryDto[],
    items: PerformerItemView[],
): {
    currentPerformanceClasses: Array<FilterItemView<PerformanceClassDto>>;
    previousPerformanceClasses: Array<FilterItemView<PerformanceClassDto>>;
    improvementGroups: Array<FilterItemView<ImprovementGroupDto>>;
} {
    const currentPerformanceClasses: PerformanceClassDto[] = [];
    const previousPerformanceClasses: PerformanceClassDto[] = [];
    const improvementGroups: ImprovementGroupDto[] = [];

    items?.forEach((e) => {
        if (
            e.performanceClass?.scorecardPerformanceClassId != null &&
            !currentPerformanceClasses.some(
                (ee) =>
                    ee.scorecardPerformanceClassId ===
                    e.performanceClass.scorecardPerformanceClassId,
            )
        ) {
            currentPerformanceClasses.push(e.performanceClass);
        }
        if (
            e.previousPerformanceClass?.scorecardPerformanceClassId != null &&
            !previousPerformanceClasses.some(
                (ee) =>
                    ee.scorecardPerformanceClassId ===
                    e.previousPerformanceClass.scorecardPerformanceClassId,
            )
        ) {
            previousPerformanceClasses.push(e.previousPerformanceClass);
        }
    });

    categories
        ?.filter(
            (e) => e.scorecardImprovementCategoryId !== NO_SCORE_NO_CLASS_ID,
        )
        .forEach((e) => {
            improvementGroups.push(...e.groups);
        });
    const noScoreGroups = categories?.find(
        (e) => e.scorecardImprovementCategoryId === NO_SCORE_NO_CLASS_ID,
    )?.groups;
    if (noScoreGroups != null) {
        improvementGroups.push(...noScoreGroups);
    }

    currentPerformanceClasses.sort((a, b) =>
        a.scorecardPerformanceClassName.localeCompare(
            b.scorecardPerformanceClassName,
        ),
    );
    previousPerformanceClasses.sort((a, b) =>
        a.scorecardPerformanceClassName.localeCompare(
            b.scorecardPerformanceClassName,
        ),
    );

    let index = currentPerformanceClasses.findIndex(
        (e) => e.scorecardPerformanceClassId === NO_SCORE_NO_CLASS_ID,
    );
    if (index !== -1) {
        currentPerformanceClasses.push(
            currentPerformanceClasses.splice(index, 1)[0],
        );
    }
    index = previousPerformanceClasses.findIndex(
        (e) => e.scorecardPerformanceClassId === NO_SCORE_NO_CLASS_ID,
    );
    if (index !== -1) {
        previousPerformanceClasses.push(
            previousPerformanceClasses.splice(index, 1)[0],
        );
    }

    // TODO revise
    [...currentPerformanceClasses, ...previousPerformanceClasses]
        .filter((e) => e.scorecardPerformanceClassId === NO_SCORE_NO_CLASS_ID)
        .forEach((e) => {
            e.scorecardPerformanceClassName = TranslationKeyMap._9402_NA;
        });

    return {
        currentPerformanceClasses: currentPerformanceClasses.map((e) => ({
            item: e,
            selected: false,
            disabled: false,
        })),
        previousPerformanceClasses: previousPerformanceClasses.map((e) => ({
            item: e,
            selected: false,
            disabled: false,
        })),
        improvementGroups: improvementGroups.map((e) => ({
            item: e,
            selected: false,
            disabled: false,
        })),
    };
}
